import { notification, Radio } from 'antd';
import { useUpdateArticleRelationIssueMutation } from 'services';

import { ISSUE_STATUS_META } from '../issue-status';

/**
 * "Sorun Var/Yok" hücresindeki dropdown menü öğelerini üretir.
 * Üç durum birbirini dışladığı için Radio kullanılır; seçili durum doğrudan
 * hasIssue prop'undan türetilir, ayrıca local state tutulmaz.
 * @param {Object} params
 * @param {string} params.id - İlişki öğesinin ID'si
 * @param {string} params.hasIssue - Sorun durumu enum'u (issue | no_issue | in_review)
 * @returns {Object[]} antd Menu items dizisi
 */
function useDropdownItems({ id, hasIssue }) {
  const [updateArticleRelationIssue] = useUpdateArticleRelationIssueMutation();

  const handleUpdateStatus = async (status) => {
    const { error } = await updateArticleRelationIssue({
      id,
      body: { hasIssue: status },
    });
    if (error) {
      return notification.error({
        message: 'Durum Güncelleme Hatası',
        description: error.data.message,
      });
    }
    notification.success({
      message: 'Durum Başarıyla Güncellendi',
    });
  };

  const items = Object.entries(ISSUE_STATUS_META).map(([status, { label }]) => ({
    key: status,
    label: (
      <Radio
        checked={hasIssue === status}
        onChange={() => handleUpdateStatus(status)}
        style={{ width: '100%' }}
      >
        {label}
      </Radio>
    ),
  }));

  return items;
}

export default useDropdownItems;
